import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap-modal'
import { ajaxGet } from '../../ajax'
import List from './games-list'

function DailyGames({date, onClose, onShowGame, onShowOpenGame}) {
  const [payload, setPayload] = useState(null)
  const [query, setQuery] = useState('')

  useEffect(() => {
    if (!payload) loadGames()
  }, [payload])

  const loadGames = () => {
    ajaxGet(`/admins/reservations/by_date.json?date=${date}`)
    .then(response => { return response.json() })
    .then((json) => setPayload(json) )
  }

  const filterList = () => {
    if (!query) return payload

    return payload.filter(game => game.master && game.master.toLowerCase().includes(query.toLowerCase()))
  }

  if (!payload) return null

  return <Modal container={document.body} dialogClassName='dailyGamesList' show={true} onHide={onClose}>
    <Modal.Header closeButton>
      <Modal.Title>Reservations List</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className='row'>
        <div className='col-md-offset-3 col-md-9'>
          <input 
            className='form-control'
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder='Type name to search'
          />
        </div>
      </div>
      <br />
      <div className='row'>
        <div className='col-sm-12'>
          <List games={filterList()} onShowGame={onShowGame} onShowOpenGame={onShowOpenGame} />
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button type='button' className='btn btn-default' onClick={onClose}>Close</button>
    </Modal.Footer>
  </Modal>
}

DailyGames.propTypes = {}

export default DailyGames
